/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { TemporalSelectorModes } from "../../layouts/TemporalSelector/TemporalSelector";
import ChartTotalsComponent from "./chartTotals.component";
import DashboardChartWrapper from "./dashboardChartWrapper.component";
import { IstogramData } from "./DashboardComponent";
import DashboarcComponentTitle from "./DashboardComponentTitle";

interface DashboardIstogramDailySellsProps {
	data: IstogramData[];
	mode: TemporalSelectorModes;
	responsiveContainerClassName: string;
}

const DashboardIstogramDailySells: React.FC<DashboardIstogramDailySellsProps> = (props) => {
	const { t } = useTranslation();
	const key = useRef(0);

	const totals = useMemo(() => {
		key.current++;
		const currentValue = props.data.length > 0 && props.data[0]?.sells !== undefined ? props.data[0].sells : 0;
		const previousValue = props.data.length > 0 && props.data[1]?.sells !== undefined ? props.data[1].sells : 0;
		return [
			{
				label: t("dashboard.current"),
				value: +currentValue.toFixed(2),
				color: "#8884d8",
				suffix: "€",
				fontSize: "3.5vw"
			},
			{
				label: t("dashboard.previous"),
				value: +previousValue.toFixed(2),
				color: "#888412",
				suffix: "€"
			}
		];
	}, [props.data]);

	const title = props.mode === TemporalSelectorModes.week ? t("dashboard.titles.weekly.total_documents") : t("dashboard.titles.monthly.total_documents");

	return (
		<DashboardChartWrapper>
			<DashboarcComponentTitle title={title} />

			<ChartTotalsComponent totals={totals} mainTotal={0} compareTotal={1} deltaSuffix="€" />
			<ResponsiveContainer height={160} className={props.responsiveContainerClassName}>
				<BarChart
					width={500}
					height={300}
					data={props.data ?? []}
					margin={{
						top: 5,
						right: 30,
						left: 20,
						bottom: 5
					}}
				>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="name" />
					<YAxis />
					<Tooltip />
					<Bar dataKey="sells" name={t("dashboard.dailySells")} fill="#82ca9d" />
				</BarChart>
			</ResponsiveContainer>
		</DashboardChartWrapper>
	);
};

export default DashboardIstogramDailySells;
